import { render, staticRenderFns } from "./SelectedFeatureComponent.vue?vue&type=template&id=794ac4a0&"
import script from "./SelectedFeatureComponent.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SelectedFeatureComponent.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports